var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"close":"","outlined":""},on:{"click":function($event){$event.stopPropagation();},"click:close":function($event){return _vm.$emit('remove', true)}}},[_c('span',{staticClass:"fs-42"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }